import { YandexMetricGoalGenqlSelection } from "@/gql/gen";

export const YandexMetrikGoalFields: YandexMetricGoalGenqlSelection = {
    ID: true,
    NAME: true,
    CODE: true,
}
